export default "__VITE_ASSET__BjCMS0Wn__"